export default __webpack_public_path__ + "static/media/rotating-card-bg-back.183088de.jpeg";